



































































import {Component, Prop, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {MsgTransports} from "@/store/types";
import {OriginatorRuleFilter, OriginatorRuleFilterImpl} from "@/store/rules/originator_rules/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {SelectWings, ToggleWings}})
export default class OriginatorRulesFilter extends BaseFilter<OriginatorRuleFilter>{
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;
  @Prop() transport!: MsgTransports;

  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getOriginatorRules") actionGetOriginatorRules: any;

  defaultFilter(): OriginatorRuleFilter {
    return new OriginatorRuleFilterImpl();
  }

  storageItemName(): string {
    return `${this.transport.toLowerCase()}OriginatorRulesFilter`;
  }

  params = {transport: this.transport.toString()};
  partnersList: any = []
  originatorsList: any = []
  serviceProvidersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    let newFilter = this.filter.partner ? {...this.params, partner: this.filter.partner, ...filter} : {...this.params, ...filter}
    const items = await this.actionGetOriginators(newFilter);
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    this.filtered();
    this.scroll();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for changing the originator",
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetOriginatorRules({
        filter : this.filter,
        transport: this.transport.toLowerCase()
      });
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      notifyError(err);
      await this.actionLog({...this.logObject, action_status: "failed"});
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter.partner')
  onPartnerChanged(val?: string, oldVal?: string) {
    if (oldVal && val !== oldVal) {
      this.filter.originator = undefined;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: OriginatorRuleFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
